export default class GatewayApiClient {

  constructor(fetch) {
    this.fetch = fetch;
  }

  getWalletBalance() {
    const endpoint = new URL('/v1/wallet/balance', process.env.UID_WEB_GATEWAY_API.URL_BASE);
    return (this.fetch || window.fetch)(endpoint.toString(), {
      credentials: 'include',
      mode       : 'cors',
    }).then((response) => {
      if (!response.ok) {
        const error = new Error(response.statusText);
        error.status = response.status;
        throw error;
      }
      return response.json();
    });
  }
}
